import { NavMenuItem } from "../components/NavigationBar";
import { getRentFinanceUrlApi } from "../swr/mortgage";

export type FUNCTION_ON_NAV_ARGS = "RENT-FINANCING";

const getRentFinanceUrl = async (
  setLoadingRentFinance: (isLoading: boolean) => void,
  openError: (message: string) => void
) => {
  try {
    setLoadingRentFinance(true);
    const { data, error } = await getRentFinanceUrlApi();

    if (error) {
      openError(error?.response?.data?.message || "Something went wrong.");
      return;
    }

    if (data?.data?.url) {
      // Partner URL is external by design, but only ever open it over https
      // so a bad value can't become a javascript:/data: link.
      let partnerUrl: URL | null = null;
      try {
        partnerUrl = new URL(data.data.url);
      } catch {}
      if (partnerUrl?.protocol !== "https:") {
        openError("Something went wrong.");
        return;
      }
      window.open(partnerUrl.href, "_blank", "noopener,noreferrer");
    }
  } catch (err: any) {
    openError(err?.message || "Something went wrong.")
  } finally {
    setLoadingRentFinance(false);
  }
};

const functionsOnNav = (f: FUNCTION_ON_NAV_ARGS) => {
  switch (f) {
    case "RENT-FINANCING":
      return getRentFinanceUrl;
    default:
      return () => {};
  }
};

const otherServices: NavMenuItem[] = [
  { label: "Utility Bill Payment", href: "/utility-bills" },
];

const servicesSubItems = [
  { label: "Save For Rent", href: "/save-for-rent" },
  { label: "UtilityBills", href: "/utility-bills" },
  { label: "Mortgage", href: "/mortgage-categories" },
  { label: "Rent Financing", href: "", onPress: functionsOnNav("RENT-FINANCING")},
  { label: "Insurance", href: "/insurance" },
  // { label: "Solar Financing", href: "/solar-financing" },
  // { label: "Smart Home Automation", href: "/smart-homes" },
];

export const menuItems: NavMenuItem[] = [
  { label: " About Us", href: "/about-us" },
  { label: "Listings", href: "/properties" },
  // { label: 'Marketplace', href: '/market-place' },
  // { label: 'Marketplace', href: '#' },
  { label: "Our Services", href: "", subItems: servicesSubItems },
  { label: "Contact", href: "/contact" },
];

// export const menuItems: NavMenuItem[] = [
//     { label: ' About Us', href: '/about-us' },
//     { label: 'Listings', href: '/properties' },
//     // { label: 'Marketplace', href: '/market-place' },
//     { label: 'Save For Rent', href: '/save-for-rent' },
//     // { label: 'Marketplace', href: '#' },
//     { label: 'UtilityBills', href: '/utility-bills' },
//     { label: 'Mortgage', href: '/mortgage-categories' },
//     // { label: 'Mortgage', href: '/mortgage-categories' },
//     { label: 'Contact', href: '/contact' },
// ]

export const menuItemsII: NavMenuItem[] = [
  { label: "Listings", href: "/properties" },
  // { label: 'Marketplace', href: '/market-place' },
  { label: "Save For Rent", href: "/save-for-rent" },
  { label: "My Account", href: "/account" },
  { label: "My Listings", href: "/mylistings" },
  { label: "Admin Dashboard", href: "/dashboardad" },
  { label: "Pension Applications", href: "/viewpensions" },
  { label: "Mortgage Applications", href: "/viewmortgage" },
  { label: "Rent Insurance Applications", href: "/viewrentinsurance" },
  { label: "UtilityBills", href: "/utility-bills" },
  { label: "Mortgage", href: "/mortgage-categories" },
  { label: "Rent Financing", href: "", onPress: functionsOnNav("RENT-FINANCING")},
  { label: "Contact", href: "/contact" },
  { label: "Add Listing", href: "/add-listing" },
  { label: "Insurance", href: "/insurance" },
  { label: "Sign In", href: "/signin" },
  { label: "Sign Up", href: "/signup" },
  { label: "Sign Out", href: "/logout" },
];
